import { Form } from 'antd'
import React, { ReactNode } from 'react'
import { useMap } from 'src/context/MapContext'

const FormItem = Form.Item

interface Props {
  children: ReactNode
}

export const WithLoadedMap: React.FC<Props> = ({ children }) => {

  const { Map, AdvancedMarkerElement, geocoder } = useMap()

  const isLoaded = !!(Map && AdvancedMarkerElement && geocoder)

  return isLoaded ? (
    children as any
  ) : (
    <FormItem
      wrapperCol={{ offset: 5 }}
    >
      Maps are loading...
    </FormItem>
  )
}


// WEBPACK FOOTER //
// ./src/component/app/map/WithLoadedMap.tsx